import { Button, ButtonBase } from '@mui/material';
import React, {
  useContext,
  useDebugValue,
  useEffect,
  useState,
} from 'react';
import {
  useAuth,
} from 'react-oidc-context';
import SetupPayment from './SetupPayment';

import ArrowForwardIosIcon from '@mui/icons-material/ArrowForwardIos';

import PaymentOutlinedIcon from '@mui/icons-material/PaymentOutlined';

import CalendarMonthOutlinedIcon from '@mui/icons-material/CalendarMonthOutlined';

import SpeciaLogo from '../../resources/speciaLogo.png';
import Subscribe from './Subscribe';

import EvaSubscribe from './EvaSubscribe';
import CancelSubscription from './CancelSubscription';
import { SnackbarContext } from '../../App';

const plans = [
  {
    plan_id: 'payg',
    plan_name: 'Pay-as-you-go',
    description: 'Pay only for what you use. The final amount is calculated based on the number of clients you have each month',
  },
  {
    plan_id: 'fixed',
    plan_name: 'Fixed-price Model',
    description: 'The price is fixed for each month regardless of the numbe rof clients added',
  },
];

const paygPlans = [
  {
    price: 7,
    percentage: 0,
    minNoClients: 0,
    description: 'Start at $7 per client per month with no minimum commitment. As your client base grows, you’ll unlock lower pricing—scale up and save!',
  },
  {
    price: 6,
    percentage: 10,
    minNoClients: 100,
    description: 'Once you exceed 100 clients, your rate drops to $6 per client per month. Keep growing to 200 clients and reduce your cost even further!',
  },
  {
    price: 5,
    percentage: 25,
    minNoClients: 200,
    description: 'Surpass 200 clients and lower your cost to $5 per client per month. Scale up to 500 clients for even greater discounts!',
  },

  {
    price: 4,
    percentage: 45,
    minNoClients: 500,
    description: 'Reach 500 clients and enjoy a lower rate of $4 per client per month. Push past 1,000 clients to unlock even more savings!',
  },
  {
    price: 3,
    percentage: 65,
    minNoClients: 1000,
    description: 'Exceed 1,000 clients and benefit from a reduced rate of $3 per client per month. Keep scaling to 2,000 clients and pay even less!',
  },
  {
    price: 2,
    percentage: 85,
    minNoClients: 2000,
    description: 'Once you surpass 2,000 clients, you get the lowest rate of just $2 per client per month. The bigger your business, the more you save!',
  },
];

function Subscription() {
  const [
    paymentMethods,
    setPaymentMethods,
  ] = useState([]);

  const auth = useAuth();

  const [
    paymentSetupShow,
    setPaymentSetupShow,
  ] = useState(false);

  const [
    subscribeShow,
    setSubscribeShow,
  ] = useState(false);

  const [
    evaSubscribeShow,
    setEvaSubscribeShow,
  ] = useState(false);

  const [
    defaultPaymentMethod,
    setDefaultPaymentMethod,
  ] = useState();

  const [
    currentNoClients,
    setCurrentNoClients,
  ] = useState();

  const [
    currentPaygRange,
    setCurrentPaygRange,
  ] = useState(1);

  const [
    finalCurrentPlan,
    setFinalCurrentPlan,
  ] = useState();

  const [
    finalEvaCurrentPlan,
    setFinalEvaCurrentPlan,
  ] = useState();

  const [
    selectedFixedPlan,
    setSelectedFixedPlan,
  ] = useState('gayatri_plan1');

  const [
    estimatedCost,
    setEstimatedCost,
  ] = useState(0);

  const [
    availablePlans,
    setAvailablePlans,
  ] = useState([]);

  const [
    evaAvailablePlans,
    setEvaAvailablePlans,
  ] = useState([]);

  const [
    currentPlan,
    setCurrentPlan,
  ] = useState([]);

  const [
    evaCurrentPlan,
    setEvaCurrentPlan,
  ] = useState([]);

  const [
    cancelSubscriptionShow,
    setCancelSubscriptionShow,
  ] = useState(false);

  const { snackBarShow, setSnackBarShow, snackBarMessage, setSnackBarMessage, sessionExpired, setSessionExpired } = useContext(SnackbarContext);

  const [
    subscriptionIdCancel,
    setSubscriptionIdCancel,
  ] = useState();

  const handlePaymentSetupSuccess = () => { fetchAvailablePaymentMethods(); setPaymentSetupShow(false); };

  function paymentSetupCloseHandler() {
    setPaymentSetupShow(false);
    fetchAvailablePaymentMethods();
  }

  function subscribeCloseHandler() {
    setSubscribeShow(false);
  }

  function evaSubscribeCloseHandler() {
    setEvaSubscribeShow(false);
  }

  // ✅ Fetch clientSecret when user clicks "Subscribe"
  const fetchAvailablePaymentMethods = async () => {
    fetch(`${window.origin}/api/stripe/payment-method`, {
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      // setSnackBarMessage('Invitation sent')
      // setSnackBarShow(true)
      return response.json();
    }).then((data) => {
      setPaymentMethods(data);

      setDefaultPaymentMethod(data.find(item => item.isDefault));

      console.log(data.find(item => item.isDefault));
    }).catch((error) => {
      console.error('Failed to fetch payment methods:', error);
      // setSnackBarMessage('Failed to send invitation. Please try again later')
      // setSnackBarShow(true)
    });
  };

  const fetchCurrentPlan = () => {
    fetch(`${window.origin}/api/stripe/plan/current`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setCurrentPlan(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const fetchEvaCurrentPlan = () => {
    fetch(`${window.origin}/api/omni2/plan/current`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setEvaCurrentPlan(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const fetchAvailablePlans = () => {
    fetch(`${window.origin}/api/stripe/plan`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setAvailablePlans(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  const fetchEvaAvailablePlans = () => {
    fetch(`${window.origin}/api/omni2/plan`, {
      method: 'GET',
      headers: {
        'Content-Type': 'application/json',
        'Authorization': `Bearer ${auth.user?.access_token}`,
      },
    }).then((response) => {
      if (response.status === 403) {
        setSessionExpired(true);
        throw new Error('Session expired');
      }
      return response.json();
    }).then((data) => {
      setEvaAvailablePlans(data);
    }).catch((error) => {
      console.error(error);
    });
  };

  async function reload() {
    fetchCurrentPlan();
    fetchEvaAvailablePlans();
    fetchEvaCurrentPlan();
    fetchAvailablePlans();
  }

  useEffect(() => {
    reload();
  }, []);

  useEffect(() => {
    if (currentPlan.length > 0 && availablePlans) {
      const currentPlanTemp = currentPlan[0];
      console.log(currentPlanTemp);
      if (currentPlan[0]?.stripe_price_id == availablePlans?.flatRate?.stripe_price?.id) {
        setFinalCurrentPlan({ planType: 'Fixed Price', ...currentPlanTemp, ...availablePlans?.flatRate?.stripe_price });
      }

      if (currentPlan[0]?.stripe_price_id == availablePlans?.payg?.stripe_price?.id) {
        setFinalCurrentPlan({ planType: 'Pay-as-you-go', ...currentPlanTemp, ...availablePlans?.payg?.stripe_price });
      }
    } else {
      setFinalCurrentPlan(null);
    }
  }, [
    currentPlan,
    availablePlans,
  ]);

  useEffect(() => {
    if (evaCurrentPlan.length > 0 && evaAvailablePlans) {
      const currentPlanTemp = evaCurrentPlan[0];
      console.log(currentPlanTemp);

      setFinalEvaCurrentPlan({ planType: 'Pay-as-you-go', ...currentPlanTemp, ...evaAvailablePlans?.payg?.stripe_price });
    } else {
      setFinalEvaCurrentPlan(null);
    }
  }, [
    evaCurrentPlan,
    evaAvailablePlans,
  ]);

  useEffect(() => {
    fetchAvailablePaymentMethods();
  }, []);

  return (
    <div style={{ padding: '0 2.5vw', paddingBottom: '2.5vw' }}>
      <p style={{ fontSize: '0.8vw', color: 'rgb(0, 15, 30, 0.6)', fontWeight: '300', textAlign: 'center', marginBottom: '2vw' }}>
        Manage your subscriptions and view info
      </p>

      <div>
        <p style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw' }}>Business Clients</p>
        <div style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '1vw', overflow: 'hidden' }}>
          <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw' }}>
            <div style={{ flex: 1, fontSize: '0.75vw', fontWeight: '500' }}>
              {finalCurrentPlan?.planType == 'Fixed Price' && <p style={{ fontSize: '1.2vw', fontWeight: '600', marginBottom: '0.8vw' }}>Fixed Price Model</p>}
              {finalCurrentPlan?.planType == 'Pay-as-you-go' && <p style={{ fontSize: '1.2vw', fontWeight: '600', marginBottom: '0.8vw' }}>Pay-as-you-go</p>}
              {!finalCurrentPlan && <p style={{ fontSize: '1.2vw', fontWeight: '600', marginBottom: '0.8vw' }}>Free Trial</p>}
              {finalCurrentPlan?.planType == 'Fixed Price' && (
                <p style={{ marginBottom: '0.5vw', fontWeight: 400 }}>
                  <PaymentOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                  <span>$3,000 per month</span>
                </p>
              )}
              {finalCurrentPlan?.planType == 'Pay-as-you-go' && (
                <p style={{ marginBottom: '0.5vw', fontWeight: 400 }}>
                  <PaymentOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                  <span>$2/client per month</span>
                </p>
              )}
              {!finalCurrentPlan && (
                <p style={{ marginBottom: '0.5vw', fontWeight: 400 }}>
                  <PaymentOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                  <span>$0 per month</span>
                </p>
              )}

              <p style={{ marginBottom: '0vw', fontWeight: 400 }}>
                <CalendarMonthOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                <span>
                  Next payment on
                  {finalCurrentPlan?.next_payment_at ? new Intl.DateTimeFormat('en-GB').format(new Date(finalCurrentPlan?.next_payment_at)) : 'NA'}
                </span>
              </p>
            </div>
            <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'space-between', alignItems: 'flex-end' }}>
              {/* <p style={{marginBottom: 0}}>Active</p> */}
              <ButtonBase
                style={{ fontSize: '0.9vw', fontWeight: '400', color: 'rgb(28, 108, 108)' }}
                onClick={() => {
                  if (!defaultPaymentMethod) {
                    setSnackBarMessage('Please add a payment method before continue');
                    setSnackBarShow(true);
                    setPaymentSetupShow(true);
                    return;
                  }

                  setSubscribeShow(true);
                }}
              >
                See All Plans
                {' '}
                <ArrowForwardIosIcon style={{ marginLeft: '0.2vw', fontSize: '0.9vw' }} />
              </ButtonBase>
            </div>

          </div>
          {!finalCurrentPlan && (
            <ButtonBase
              onClick={() => {
                if (!defaultPaymentMethod) {
                  setSnackBarMessage('Please add a payment method before continue');
                  setSnackBarShow(true);
                  setPaymentSetupShow(true);
                  return;
                }

                setSubscribeShow(true);
              }}
              style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)' }}
            >
              <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                <p style={{ margin: 0 }}>Upgrade Plan</p>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
              </div>
            </ButtonBase>
          )}
          {finalCurrentPlan && (
            <ButtonBase onClick={() => { setCancelSubscriptionShow(true); setSubscriptionIdCancel(finalCurrentPlan?.stripe_subscription_id); }} style={{ color: 'red', width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)' }}>
              <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                <p style={{ margin: 0 }}>Cancel Subscription</p>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
              </div>
            </ButtonBase>
          )}

        </div>
      </div>

      <div style={{ marginTop: '2vw', visibility: 'hidden' }}>
        <p style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.8vw', paddingLeft: '0.5vw', margin: 0, marginBottom: '0.8vw' }}>Individual Clients</p>
        <div style={{ color: 'rgb(0, 15, 30, 0.6)', fontSize: '0.9vw', marginTop: '1vw', backgroundColor: 'rgb(254, 254, 255, 0.6)', borderRadius: '1vw', overflow: 'hidden' }}>
          <div style={{ display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw' }}>
            <div style={{ flex: 1, fontSize: '0.75vw', fontWeight: '500' }}>
              {finalEvaCurrentPlan && <p style={{ fontSize: '1.2vw', fontWeight: '600', marginBottom: '0.8vw' }}>Pay-as-you-go</p>}
              {!finalEvaCurrentPlan && <p style={{ fontSize: '1.2vw', fontWeight: '600', marginBottom: '0.8vw' }}>Free Trial</p>}
              {finalEvaCurrentPlan?.planType == 'Pay-as-you-go' && (
                <p style={{ marginBottom: '0.5vw', fontWeight: 400 }}>
                  <PaymentOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                  <span>$5/client per year</span>
                </p>
              )}
              {!finalEvaCurrentPlan && (
                <p style={{ marginBottom: '0.5vw', fontWeight: 400 }}>
                  <PaymentOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                  <span>$0 per month</span>
                </p>
              )}

              <p style={{ marginBottom: '0vw', fontWeight: 400 }}>
                <CalendarMonthOutlinedIcon style={{ fontSize: '1.2vw', marginRight: '0.5vw', marginBottom: '0.1vw' }} />
                <span>
                  Next payment on
                  {evaCurrentPlan?.next_payment_at ? new Intl.DateTimeFormat('en-GB').format(new Date(evaCurrentPlan?.next_payment_at)) : 'NA'}
                </span>
              </p>
            </div>

          </div>
          {evaCurrentPlan?.length == 0 && (
            <ButtonBase
              onClick={() => {
                if (!defaultPaymentMethod) {
                  setSnackBarMessage('Please add a payment method before continue');
                  setSnackBarShow(true);
                  return;
                }

                setEvaSubscribeShow(true);
              }}
              style={{ width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)' }}
            >
              <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                <p style={{ margin: 0 }}>Upgrade Plan</p>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
              </div>
            </ButtonBase>
          )}
          {evaCurrentPlan?.length > 0 && (
            <ButtonBase onClick={() => { setCancelSubscriptionShow(true); setSubscriptionIdCancel(finalEvaCurrentPlan?.stripe_subscription_id); }} style={{ color: 'red', width: '100%', display: 'flex', flexDirection: 'row', padding: '1vw 1.5vw', borderTop: '1px solid rgb(0, 15, 30, 0.05)' }}>
              <div style={{ flex: 1, fontWeight: '600', textAlign: 'left' }}>
                <p style={{ margin: 0 }}>Cancel Subscription</p>
              </div>
              <div style={{ flex: 1, textAlign: 'right' }}>
                <ArrowForwardIosIcon style={{ fontSize: '1vw' }} />
              </div>
            </ButtonBase>
          )}

        </div>
      </div>

      <SetupPayment show={paymentSetupShow} onHide={paymentSetupCloseHandler} onSuccess={handlePaymentSetupSuccess} />

      <Subscribe show={subscribeShow} reloadHandler={reload} closeHandler={subscribeCloseHandler} plans={plans} paygPlans={paygPlans} selectedFixedPlan={selectedFixedPlan} currentPaygRange={currentPaygRange} currentPlan={finalCurrentPlan} currentNoClients={currentNoClients} availablePlanTypes={availablePlans} />

      <EvaSubscribe show={evaSubscribeShow} reloadHandler={reload} closeHandler={evaSubscribeCloseHandler} defaultPaymentMethod={defaultPaymentMethod} currentPlan={finalEvaCurrentPlan} availablePlanTypes={evaAvailablePlans} />

      <CancelSubscription show={cancelSubscriptionShow} onHide={() => { setCancelSubscriptionShow(false); }} subId={subscriptionIdCancel} onReload={reload} />

    </div>
  );
}

export default Subscription;
